// extracted by extract-css-chunks-webpack-plugin
module.exports = {"btn":"info-bubble__btn--RjjXs"};